import * as React from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useServiceOrdersSearchParams } from 'hooks/store/service-orders';
import { useFetchServiceOrders } from 'hooks/api/service-orders';
import { useOffsetTop } from 'hooks/ui';
import { Scaffold } from 'layouts';
import { PageHeaderWithCheckboxes } from 'components/ui/page-header-with-checkboxes';
import { DataTable } from 'components/ui/DataTable';

import { TabbedNavigation, Indicators } from '../shared-components';
import { usePageHeaderConfig, useServiceOrderColumns } from './hooks';
import {
  ServiceOrdersFilter,
} from './components';

export const ServiceOrdersPage = () => {
  const navigate = useNavigate();
  const { filters, updateFilters, updateCurrentStatus, clearState } = useServiceOrdersSearchParams();
  const { fetchServiceOrders } = useFetchServiceOrders();
  const { checkboxesConfig, loadingConfig } = usePageHeaderConfig();

  const datatableWrapperRef = React.useRef<HTMLDivElement>(null);

  const datatableWrapperOffsetTop = useOffsetTop({
    ref: datatableWrapperRef,
    updateInterval: 1000,
  });

  const datatableWrapperStyle = React.useMemo((): React.CSSProperties => {
    return {
      minHeight: '100px',
      maxHeight: `calc(100vh - ${datatableWrapperOffsetTop + 150}px)`,
    };
  }, [datatableWrapperOffsetTop]);

  const columns = useServiceOrderColumns();

  const serviceOrdersQuery = useQuery({
    queryKey: ['service-orders', filters],
    queryFn: () => fetchServiceOrders({ filters }),
    refetchOnWindowFocus: false,
  });

  return (
    <Scaffold>
      <TabbedNavigation />
      <PageHeaderWithCheckboxes
        checkboxesConfig={checkboxesConfig}
        loadingConfig={loadingConfig}
        className={'mb-6'}
      >
        <ServiceOrdersFilter
          onSubmitFilters={updateFilters}
          onResetFilters={clearState}
          onStatusesChange={updateCurrentStatus}
        />
      </PageHeaderWithCheckboxes>
      <Indicators
        indicators={serviceOrdersQuery?.data?.indicators}
        loading={serviceOrdersQuery.isLoading}
        className={'mb-4'}
      />
      <div ref={datatableWrapperRef}>
        <DataTable
          data={serviceOrdersQuery?.data?.serviceOrders ?? []}
          isLoading={serviceOrdersQuery.isLoading}
          columns={columns}
          tableWrapperStyle={datatableWrapperStyle}
          leftPinnedColumns={['Prior.']}
          onRowClick={(row) => {
            navigate(`/inspecao-estoque/ordem-servico/${row.original.id}`);
          }}
        />
      </div>
    </Scaffold>
  );
};